import React, { useState, useEffect, useCallback } from "react";
import FollowUpActionsContractsContractView from "./follow-up-actions-contracts-contract.view";
import FollowUpActionsContractsDiscussionView from "./follow-up-actions-contracts-discussion.view";
import FollowUpActionsContractsQuestionnaireView from "./follow-up-actions-contracts-questionnaireview";
import ContractGeneratedView from "./questionsSection/contract-generated-view";
const FollowUpConfigurationsView = (props) => {
  const {
    hideShowDetails,
    nameComponentUser,
    setShowDetails,
    setNameComponentUser,
    status,
    token,
    showCompletedRequesting,
    showErrorRequesting,
    showWarningRequesting,
    setQuestionsAnswered,
    setUrlPdf,
    questions,
    clientContractId,
    showLoadingRequesting,
    toggleLoadingRequesting,
    toggleCompletedRequesting,
    toggleErrorRequesting,
    contract,
    conversation,
    usersChat,
    handleInputChange,
    createMessage,
    handleDeleteFile,
    handleFile,
    showAWS,
    handleShowModal,
    urlPdfModal,
    showModalPdf,
    documentSelected,
    handleCloseModal,
    handleUpdateAnswerRawRecDoc
  } = props

  const [stateNameComponentUser, setStateNameComponentUser] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setStateNameComponentUser(nameComponentUser);
  }, [nameComponentUser]);

  useEffect(() => {
    renderComponent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateNameComponentUser]);

  const renderComponent = useCallback(() => {
    switch (stateNameComponentUser) {
      case "Discusion":
        return (
          <FollowUpActionsContractsDiscussionView
            hideShowDetails
            setShowDetails={setShowDetails}
            setNameComponentUser={setNameComponentUser}
            conversation={conversation}
            usersChat={usersChat}
            handleInputChange={handleInputChange}
            createMessage={createMessage}
          />
        );
      case "Consultar cuestionario":
        return (
          <ContractGeneratedView
            {...props}
            hideShowDetails={hideShowDetails}
            isMobile={true}
            status={status}
            setUrlPdf={setUrlPdf}
            setQuestionsAnswered={setQuestionsAnswered}
            questions={questions}
            clientContractId={clientContractId}
            token={token}
            heightContainer={"350px"}
            showLoadingRequesting={showLoadingRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            handleFile = {handleFile}
            handleDeleteFile = {handleDeleteFile}
            handleShowModal = {handleShowModal}
            urlPdfModal = {urlPdfModal}
            showModalPdf = { showModalPdf}
            documentSelected = {documentSelected}
            handleCloseModal = {handleCloseModal}
            handleUpdateAnswerRawRecDoc = {handleUpdateAnswerRawRecDoc}
          />
        );
      case "Consultar contrato":
        return (
          <FollowUpActionsContractsContractView
            contract={contract}
            setShowDetails={setShowDetails}
            setNameComponentUser={setNameComponentUser}
          />
        );
      default:
        return;
    }
  }, [
    stateNameComponentUser,
    hideShowDetails,
    token,
    showCompletedRequesting,
    showErrorRequesting,
    showWarningRequesting,
  ]);

  return <>{renderComponent()}</>;
};

export default FollowUpConfigurationsView;
